import * as React from "react";
import {cx} from "emotion";

import "./slider-checkbox-line.scss";

import {cs}             from "@Common/react/chain-services";
import {SliderCheckbox} from "@Common/ui-components/slider-checkbox/slider-checkbox";

export const SliderCheckboxLine = ({label, value, onChange=undefined, className, xdQaName=undefined}) => cs(
    () => (
        <div {...{
            className: cx("slider-checkbox-line slider-checkbox-line-0qb", className),
            ...onChange && {
                onClick: () => onChange?.(!value),
            },
        }}>
            <div {...{
                className: "label",

                ...xdQaName && {
                    "xd-qa-type": "label",
                    "xd-qa-name": xdQaName,
                },
            }}>
                {label}
            </div>

            {SliderCheckbox({
                value,
                // onChange,
                xdQaName,
                disabled: onChange == null,
            })}
        </div>
    ),
);
